<div id="planningCollaborateur">
  <mat-card class="example-card">
    <mat-card-header class="titreFrm">
      <mat-card-title>{{
        "Planning Collaborateurs".toUpperCase()
      }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <mat-accordion>
        <mat-expansion-panel [expanded]="expanded">
          <mat-expansion-panel-header
            [collapsedHeight]="'30px'"
            [expandedHeight]="'30px'"
          ></mat-expansion-panel-header>
          <div class="btn">
            <button (click)="afficherDate()" mat-raised-button color="primary">
              <mat-icon>search</mat-icon>Afficher
            </button>
          </div>
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Collaborateurs</mat-label>
              <mat-select
                [disabled]="disabled"
                (selectionChange)="afficherDate()"
                placeholder="Collaborateurs"
                name="collaborateur"
                [(ngModel)]="collaborateur"
              >
                <mat-option
                  *ngFor="let Perso of listeCollaborateurs"
                  [(ngModel)]="Perso.Perso_Matricule"
                >
                  {{ Perso.NomPrenom }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Du</mat-label>
              <input
                matInput
                [matDatepicker]="dateDebut"
                placeholder="Du"
                [(ngModel)]="date_Debut"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateDebut"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateDebut></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Au</mat-label>
              <input
                matInput
                [matDatepicker]="dateFin"
                placeholder="Au"
                [(ngModel)]="date_Fin"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateFin"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateFin></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="display-flex liste-btn">
            <div *ngFor="let week of listWeek" class="div-btn">
              <button
                [disabled]="!week.enable"
                mat-raised-button
                (click)="showDetaille(week.monthName, 7)"
                color="primary"
              >
                <span>{{ week.colSpan }}</span
                >&nbsp;&nbsp;<span style="font-size: 10px">{{
                  week.monthName
                }}</span>
              </button>
            </div>
          </div>
          <div class="display-flex liste-btn">
            <div *ngFor="let month of listMonth" class="div-btn">
              <button
                [disabled]="!month.enable"
                (click)="
                  showDetaille(
                    '1/' + (month.monthId + 1) + '/' + month.year,
                    30
                  )
                "
                mat-raised-button
                color="primary"
              >
                {{ month.monthName }}
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div style="margin-top: 10px">
        <app-calendar
          *ngIf="showCalendar"
          [events]="events"
          [intervale]="intervale"
          [date_Fin]="date_Fin"
          [date_Debut]="date_Debut"
          [defaultDate]="defaultDate"
          (actionCalendar)="actionCalendar($event)"
        >
        </app-calendar>
      </div>
    </mat-card-content>
  </mat-card>
</div>
